import { render } from "./SupplierSearch.vue?vue&type=template&id=4097649b&ts=true"
import script from "./SupplierSearch.vue?vue&type=script&lang=ts"
export * from "./SupplierSearch.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__